import { BetterStackLoggerService } from './BetterStackLogger';
import { DatadogLoggerService } from './DatadogLogger';
import { ParallelLoggerService } from './ParallelLogger';
import type { ILogger } from '@types';

// BetterStack and Datadog run in parallel during the migration; drop the
// BetterStack transport (and its deprecated service) once Datadog is validated.
export const logger: ILogger = new ParallelLoggerService([
  new BetterStackLoggerService(),
  new DatadogLoggerService(),
]);
